import { useState } from 'react';
import { AppDialogLayout } from '@/components/system';
import AnamnesisStartStep from './AnamnesisStartStep';
import { describePatient } from './resolve-template';
import type { AnamnesisTemplateId } from './templates';
import type { Patient } from '@/types/patient';

type Props = {
    patientId: string;
    patient?: Patient;
    onSelect: (templateId: AnamnesisTemplateId) => void;
    onUploaded: () => void;
};

/**
 * The patient-page entry to the start step. The patient is already known here, so
 * the only back actions are "leave the gallery/upload" — rendered in the dialog
 * header, the same place the global wizard puts them.
 */
export default function AnamnesisStartModal({ patientId, patient, onSelect, onUploaded }: Props) {
    const [showGallery, setShowGallery] = useState(false);
    const [showUpload, setShowUpload] = useState(false);

    const back = showUpload
        ? () => setShowUpload(false)
        : showGallery
          ? () => setShowGallery(false)
          : undefined;

    return (
        <AppDialogLayout
            title="Nova anamnese"
            description={describePatient(patient)}
            backAction={back ? { label: 'Voltar', onClick: back } : undefined}
        >
            <AnamnesisStartStep
                patientId={patientId}
                patient={patient}
                showGallery={showGallery}
                onShowGallery={() => setShowGallery(true)}
                showUpload={showUpload}
                onShowUpload={() => setShowUpload(true)}
                onSelect={onSelect}
                onUploaded={onUploaded}
            />
        </AppDialogLayout>
    );
}
